import React from "react";
import { createApi } from "./createApi";
import { markSiteSynced } from "./syncStore";
import { AxiosError } from "axios";
import { universalAPIErrorHandler } from "./universalAPIErrorHandler";
import { handleDeployNextFailure } from "./handleDeployNextFailure";

export const syncSite = async (siteId: string, navigate: any) => {
  const AxiosUI = createApi(``);
  const retryFunction = () => {
    syncSite(siteId, navigate);
  };
  await AxiosUI.post(`customer/${siteId}/action/deploy_next/`).then(
    () => {
      markSiteSynced();
      // Syncing pushes the latest settings to the cloud but does NOT make them
      // live on an already-running connector — that needs a reboot. Arm the
      // one-shot reboot prompt so the About page offers to reboot (armed sites
      // only) the next time the operator lands there. This is the single place
      // "reboot needed" is set now that saving no longer auto-syncs.
      localStorage.setItem("rebootSite", "true");
    },
    (reason: AxiosError) => {
      universalAPIErrorHandler(
        reason,
        navigate,
        retryFunction,
        handleDeployNextFailure
      );
    }
  );
};
